import React from 'react';
import ArticleDetailUI from './ContentUI';

const ArticleDetail = ({ data }: { data: any }) => {
  return (
    <ArticleDetailUI
      model={data['model']}
      // gptsList={data['gptsList']}
      articleList={data['articleList']}
      contentData={data['contentData']}
      recommendTags={data['recommendTags']}
      recommandArtcles={data['recommandArtcles']}
      h2Texts={data['h2Texts']}
    />
  );
};

export default ArticleDetail;
